import { Link } from "react-router-dom";
import ProfileDropdown from "./profileDropdown";
import { useLocation } from "react-router-dom";
import { useContext, useState } from "react";

import logo from '../../../assets/images/ShadowzLogo.svg'


import {
  REPORTED_POSTS,
  ROLES_BACKUP,
  ROLES_CONTACT_US,
  ROLES_CREATOR,
  ROLES_DASHBOARD,
  ROLES_TRANSACTIONS,
  ROLES_FAQS,
  ROLES_SUSCRIBES,
  ROLES_NFTS,
  ROLES_NOTIFICATION,
  ROLES_POLICIES,
  ROLES_REPORTS,
  ROLES_SALES,
  ROLES_USERS,
} from "../../../constants/actionTypes";
import { GlobalContext } from "../../../context/Provider";


const MenuItems = [
  {
    name: "Reported Posts",
    path: "/reported-posts",
    icon: "",
    role: REPORTED_POSTS,
  },

];

export default (props) => {
  const { authState } = useContext(GlobalContext);
  const roles = Array.isArray(authState.roles) ? authState.roles : [];

  let location = useLocation();
  const [isOpen, setIsOpen] = useState(true); // default open
  //logout
  const { logOutNow } = useContext(GlobalContext);
  return (
    <nav
      class={`navbar-default navbar-static-side ${props.isVisible === true ? "open-nav" : ""
        }`}
      role="navigation"
    >
      <div class="sidebar-collapse">
        <div className="arrow d-md-none" onClick={props.toggle}>
          <i class="fa fa-times"></i>
        </div>
        <ul class="nav" id="side-menu">
          <li class="nav-header  text-start p-4">
            <img className="logo-img" height={25} src={logo} />
            {/* <ProfileDropdown logOutNow={props.logOutNow} roles={roles} />
            <div class="logo-element">IN+</div> */}
          </li>

          {roles.includes(ROLES_DASHBOARD) || authState.super_admin ? (
            <li className={location.pathname === "/" ? "active" : ""}>
              <Link
                style={{ textDecoration: "none" }}
                to="/"
              >
                <i class="fa fa-th-large"></i>{" "}
                <span class="nav-label ">Dashboard</span>
              </Link>
            </li>
          ) : (
            ""
          )}

          {roles.includes(ROLES_USERS) || authState.super_admin ? (
            <li
              className={
                location.pathname.includes("/users") ||
                  location.pathname.includes("/user/")
                  ? "active"
                  : ""
              }
            >
              <Link
                style={{ textDecoration: "none" }}
                to="/users/1"
              >
                <i class="fas fa-users"></i>{" "}
                <span class="nav-label">Users</span>
              </Link>
            </li>
          ) : (
            ""
          )}

          {roles.includes(ROLES_CREATOR) || authState.super_admin ? (
            <li
              className={location.pathname.includes("/posts") ? "active" : ""}
            >
              <Link
                style={{ textDecoration: "none" }}
                to="/posts/1"
              >

                <i class="fas fa-images"></i>
                <span class="nav-label">Posts</span>
              </Link>
            </li>
          ) : (
            ""
          )}

          {roles.includes(ROLES_NFTS) || authState.super_admin ? (
            <li
              className={location.pathname.includes("/stories") ? "active" : ""}
            >
              <Link
                style={{ textDecoration: "none" }}
                to="/stories/1"
              // className="sideBarColor"
              >
                <i class="far fa-photo-video"></i>
                <span class="nav-label">Stories</span>
              </Link>
            </li>
          ) : (
            ""
          )}


          {roles.includes(ROLES_SALES) || authState.super_admin ? (
            <li
              className={location.pathname.includes("/race") ? "active" : ""}
            >
              <Link
                style={{ textDecoration: "none" }}
                to="/race"
              // className="sideBarColor"
              >
                <i class="fas fa-play"></i> <span class="nav-label">Race</span>
              </Link>
            </li>
          ) : (
            ""
          )}

          {/* {roles.includes(ROLES_SALES) || authState.super_admin ? (
            <li
              className={location.pathname.includes("/reels") ? "active" : ""}
            >
              <Link
                style={{ textDecoration: "none" }}
                to="/reels/1"
              // className="sideBarColor"
              >
                <i class="fas fa-play"></i> <span class="nav-label">Reels</span>
              </Link>
            </li>
          ) : (
            ""
          )} */}

          {/* Posts, reels, stories */}

          {roles.includes(ROLES_SALES) || authState.super_admin ? (
            <li>
              <div>
                {/* Accordion Header */}
                <button
                  onClick={() => setIsOpen(!isOpen)}
                  className={`${location.pathname.includes("/reported") ? "bg-black text-white" : "text-gray-800"} flex items-center w-full px-4 py-2 text-left font-bold hover:text-white hover:bg-black focus:outline-none`}
                >
                  <i className="fas fa-folder mr-2"></i>
                  <span className="nav-label">Reported</span>
                  <span className="ml-[0.5vw]">
                    {isOpen ? (
                      <i className="fas fa-chevron-up text-sm"></i>
                    ) : (
                      <i className="fas fa-chevron-down text-sm"></i>
                    )}
                  </span>
                </button>

                {/* Accordion Body */}
                <div
                  className={`transition-all duration-300 overflow-hidden ${isOpen ? "max-h-screen" : "max-h-0"}`}
                >
                  <ul className="list-none pl-6 py-2 space-y-1">

                    {(roles.includes(REPORTED_POSTS) || authState.super_admin) && (
                      <li className={`${location.pathname.includes("/reported-posts") ? "bg-black text-white font-bold" : ""}`}>
                        <Link
                          to="/reported-posts/1"
                          className="flex items-center px-2 py-1 font-bold hover:text-white hover:bg-black transition-colors"
                        >
                          <i className="fas fa-images mr-2"></i> Posts
                        </Link>
                      </li>
                    )}

                    {(roles.includes(ROLES_SALES) || authState.super_admin) && (
                      <li className={`${location.pathname.includes("/reported-race") ? "bg-black text-white font-bold" : ""}`}>
                        <Link
                          to="/reported-race"
                          className="flex items-center px-2 py-1 font-bold hover:text-white hover:bg-black transition-colors"
                        >
                          <i className="fas fa-play mr-2"></i> Race
                        </Link>
                      </li>
                    )}

                    {(roles.includes(ROLES_SALES) || authState.super_admin) && (
                      <li className={`${location.pathname.includes("/reported-stories/1") ? "bg-black text-white font-bold" : ""}`}>
                        <Link
                          to="/reported-stories/1"
                          className="flex items-center px-2 py-1 font-bold hover:text-white hover:bg-black transition-colors"
                        >
                          <i className="far fa-photo-video mr-2"></i> Stories
                        </Link>
                      </li>
                    )}

                    {(roles.includes(REPORTED_POSTS) || authState.super_admin) && (
                      <li className={`${location.pathname.includes("/reported-chat") ? "bg-black text-white font-bold" : ""}`}>
                        <Link
                          to="/reported-chat/1"
                          className="flex items-center px-2 py-1 font-bold hover:text-white hover:bg-black transition-colors"
                        >
                          <i className="fas fa-images mr-2"></i> Chat
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </li>
          ) : null}



          {/* {roles.includes(ROLES_TRANSACTIONS) || authState.super_admin ? (
            <li className="">
              <Link
                style={{ textDecoration: "none" }}
                to="/transaction/1?filter=SEND"
                className={
                  location.pathname.includes("/transaction/1")
                    ? "active"
                    : ""
                }
              >
         

                <i class="fas fa-dollar-sign"></i>{" "}
                <span class="nav-label">Transactions</span>
              </Link>
            </li>
          ) : (
            ""
          )} */}
          {/* {roles.includes(ROLES_SUSCRIBES) || authState.super_admin ? (
            <li className="">
              <Link
                style={{ textDecoration: "none" }}
                to="/suscriber/1"
                className={
                  location.pathname.includes("/subscriber/1")
                    ? "active"
                    : ""
                }
              // className="sideBarColor"
              >



                <i class="fab fa-youtube"></i>{" "}
                <span class="nav-label">Suscribers</span>
              </Link>
            </li>
          ) : (
            ""
          )} */}
          {roles.includes(ROLES_SALES) || authState.super_admin ? (
            <li
              className={
                location.pathname.includes("/user-Messages") ||
                  location.pathname.includes("/user-Message-Details/")
                  ? "active"
                  : ""
              }
            >

              <Link
                style={{ textDecoration: "none" }}
                to="/user-Messages/1"
              // className="sideBarColor"
              >
                <i class="fas fa-envelope-open-text"></i>{" "}
                <span class="nav-label">Support</span>
              </Link>
            </li>
          ) : (
            ""
          )}
          {roles.includes(ROLES_SALES) || authState.super_admin ? (
            <li
              className={
                location.pathname.includes("/notification") ? "active" : ""
              }
            >
              <Link
                style={{ textDecoration: "none" }}
                to="/notification"
              // className="sideBarColor"
              >
                <i class="fas fa-bell"></i>{" "}
                <span class="nav-label">Notification</span>
              </Link>
            </li>
          ) : (
            ""
          )}
          {roles.includes(ROLES_SALES) || authState.super_admin ? (
            <li
              className={
                location.pathname.includes("/termServicesPrivacyPolicy")
                  ? "active"
                  : ""
              }
            >
              <Link
                style={{ textDecoration: "none" }}
                to="/policies"
              //  className="sideBarColor"
              >
                <i class="far fa-file-alt"></i>{" "}
                <span class="nav-label">Policies </span>
              </Link>
            </li>
          ) : (
            ""
          )}
          {roles.includes(ROLES_SALES) || authState.super_admin ? (
            <li
              className={
                location.pathname.includes("/change-password") ? "active" : ""
              }
            >
              <Link
                style={{ textDecoration: "none" }}
                to="/change-password"
              // className="sideBarColor"
              >
                <i class="fas fa-key"></i>{" "}
                <span class="nav-label">Change Password</span>
              </Link>
            </li>
          ) : (
            ""
          )}



          {/* {MenuItems.map((res) => {
            return roles.includes(res.role) || authState.super_admin ? (
              <li className={location.pathname.includes() ? "active" : ""}>
                <Link to={res.path}>
                  <i class={res?.icon}></i>{" "}
                  <span class="nav-label">{res.name}</span>
                </Link>
              </li>
            ) : (
              ""
            );
          })} */}

          {/* <button className="btn btn-primary" onClick={() => logOutNow()}>
                <i class="fa fa-sign-out"></i> Log out
              </button> */}
        </ul>
      </div>
    </nav>
  );
};
